export const PAGES = {
  TICKET_OPTIONS: "ticket_options",
  RESULTS: "results",
  ASYNC_CART: "async_cart",
  SEAT_SELECTION: "seat_selection",
  CHECKOUT: "checkout"
} as const;

export type Page = (typeof PAGES)[keyof typeof PAGES];

export type Drawer = (typeof DRAWERS)[keyof typeof DRAWERS];
export const DRAWERS = {
  TICKET_OPTIONS: "selection-options",
  SEAT_SELECTION: "seat-selection"
} as const;
